import { createApp } from "vue";
import App from "./App.vue";
// import { Table } from "ant-design-vue";
// import "ant-design-vue/dist/antd.css";
import router from "./router";
import "amfe-flexible";
import VConsole from "vconsole";
import "./assets/style/index.css";
import "vant/lib/index.css";

if (process.env.NODE_ENV !== "production") {
  new VConsole({ theme: "dark" });
}

import {
  Col,
  Row,
  Uploader,
  Field,
  Form,
  Button,
  // showToast,
  Overlay,
  Loading,
  NavBar,
} from "vant";

createApp(App)
  .use(router)
  .use(Col)
  .use(Row)
  .use(Field)
  .use(Uploader)
  .use(Form)
  .use(Button)
  .use(Overlay)
  .use(Loading)
  .use(NavBar)
  .mount("#app");
